/**
 * Created by Jan Bradac on 5.8.2016.
 */

(function (Lfl, $, undefined) {
    /**
     * Set of classes that help work with jQuery UI events.
     *
     * @memberOf Lfl
     */
    Lfl.Events;

    (function (Events, $, undefined) {
        if(Lfl.Files.isLoadedAlready(Lfl.Events, 'Events')) {
            return;
        }

    }(Lfl.Events = Lfl.Events || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
    